import { FilesUploadEffects } from './files-upload.effects'

export const effects = [FilesUploadEffects]
